import { getEnvVariables } from '../../services/optionsService';

export const getLoginAppUrl = (): string => {
  const { environment } = getEnvVariables();

  if (environment === 'prod') {
    return 'https://login.openx.com';
  }

  return `https://login-${environment}.openx.com`;
};
